export const SPACES_SORT_TYPES = {
    ALPHABETICAL: "ALPHABETICAL",
    SPACE_ORDER: "SPACE_ORDER",
};
